import { normalize } from 'normalizr'

// Schemas
import { songList as songListSchema } from 'normalize'
import { collectionListSchema } from 'modules/collections/models'

// Types
import { APIAction, CmsPage, Dispatch } from 'types'
import { pageListSchema, pageSchema, pageSummaryListSchema } from 'modules/cms/models'

const extractAttached = (res: { data: { response: { result: Array<number>; entities: { pages: Array<CmsPage> } } } }, label: string) => {
  if (!(res && res.data && res.data.response.entities && res.data.response.entities.pages)) {
    return null
  }
  const pageId = res.data.response.result[0]
  const page = res.data.response.entities.pages[pageId]
  return page && page.content.filter(b => b.type === 'track').map(b => b.value && b.value[label])
}

export const actions = {
  fetchAllArticleSummaries: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_ALL_ARTICLE_SUMMARIES',
      method: 'GET',
      endpoint: '/api/static/article/?fields=id,title,title_max_length,categories,summary,image,author,introduction,video',
      schema: pageSummaryListSchema,
      merge: true,
    },
  }),

  fetchArticlesByIds: (articleIds: Array<number>): APIAction => ({
    CALL_API: {
      type: 'FETCH_SPECIFIC_STATIC_ARTICLES',
      method: 'GET',
      endpoint: `/api/static/article/?id=${articleIds.join(
        ',',
      )}&fields=id,title,title_max_length,content,categories,summary,image,mobile_override_image,author,introduction,video`,
      schema: pageListSchema,
      merge: true,
    },
  }),

  fetchArticleSummariesByCategory: (category: string): APIAction => ({
    CALL_API: {
      type: 'FETCH_ARTICLE_SUMMARIES_BY_CATEGORY',
      method: 'GET',
      endpoint: `/api/static/article/?category=${category}&fields=id,title,title_max_length,content,categories,summary,image,author,introduction,video`,
      schema: pageSummaryListSchema,
      merge: true,
    },
  }),

  _fetchArticleBySlug: (slug: string): APIAction => ({
    CALL_API: {
      type: 'FETCH_ARTICLE_BY_SLUG',
      method: 'GET',
      endpoint: `/api/static/article/find/?html_path=blog/${slug}/`,
      requestKey: slug,
      schema: pageSchema,
      merge: true,
    },
  }),

  fetchArticleBySlug: (slug: string) => (dispatch: Dispatch) =>
    dispatch(actions._fetchArticleBySlug(slug)).then(result => {
      const pageEntities = result?.data?.response?.entities?.pages
      if (pageEntities) {
        const collections = Object.keys(pageEntities).reduce((agg, pageKey) => {
          const pageCollections = pageEntities[pageKey].collections
          if (pageCollections) {
            return [...agg, ...pageCollections]
          }
          return agg
        }, [])

        const entitiesFromCollection = collections && collections.length ? normalize(collections, collectionListSchema) : null
        const songs = (extractAttached(result, 'inline_songs') || []).reduce((agg, songList) => [...agg, ...songList], [])
        const entities = songs && songs.length ? normalize(songs, songListSchema) : null
        if (entitiesFromCollection) {
          dispatch({
            type: 'COLLECTION_FETCH_DONE',
            data: { response: entitiesFromCollection },
          })
        }
        return dispatch({
          type: 'FETCH_SONG_DONE',
          data: { response: entities },
        })
      }
      return Promise.resolve()
    }),
}
